import { QUERY_PARAMS, DATA_TYPES_FOR_PARAMS } from '../searchFlyoutConfig';
import { DataType } from '../types';

export const getSearchParams = (search: string) => {
  const params = new URLSearchParams(search);
  const getDataType = params.get('dataType');
  const loanId = params.get('loanId') ?? '';
  let dataType: DataType | undefined;
  if (!!getDataType) {
    const storedValue = getDataType!;
    const match = Object.entries(DATA_TYPES_FOR_PARAMS).find(([, value]) => value === storedValue);
    dataType = match?.[0] as DataType;
  }
  const searchQuery: Record<string, string> = {};
  params.forEach((value, key) => {
    if (QUERY_PARAMS.includes(key)) {
      searchQuery[key] = value.trim();
    }
  });

  return { dataType, searchQuery, loanId };
};
